import type { SvpCategoryId } from '@vgtv/api-client/lib/svp_category';
import type { CnpTagId } from '@vgtv/api-client/lib/cnp_tag';
import type { CnpStoryId } from '@vgtv/api-client/lib/cnp_story';

import type { Vendor } from '../../types';

import type { PagesState } from './index';

type State = { pages: PagesState };

export const selectPageByCategory = (
  state: State,
  categoryId: SvpCategoryId,
  vendor: Vendor
) => state.pages[vendor].byCategoryId?.[categoryId];

export const selectPageByTag = (
  state: State,
  tagId: CnpTagId,
  vendor: Vendor
) => state.pages[vendor].byTagId?.[tagId];

export const selectPageByStory = (
  state: State,
  storyId: CnpStoryId,
  vendor: Vendor
) => state.pages[vendor].byStoryId?.[storyId];

export const selectPageBySlug = (state: State, slug: string, vendor: Vendor) =>
  state.pages[vendor].bySlug?.[slug];
